export default __webpack_public_path__ + "static/media/mobile_advance.6402ac22.svg";